<div class="layout-topbar">
  <button #menuButton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
    <i class="pi pi-bars"></i>
  </button>
  <a class="layout-topbar-logo" routerLink="">
<!--    <img src="assets/layout/images/{{layoutService.config().colorScheme === 'light' ? 'logo-dark' : 'logo-white'}}.svg" alt="logo">-->
    <span>Bill Note</span>
  </a>



  <button #topBarMenuButton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
    <i class="pi pi-ellipsis-v"></i>
  </button>

  <div #topBarMenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
<!--    <button class="p-link layout-topbar-button">-->
<!--      <i class="pi pi-calendar"></i>-->
<!--      <span>Calendar</span>-->
<!--    </button>-->
    <button class="p-link layout-topbar-button">
      <i class="pi pi-user"></i>

    </button>
    <span class="pt-3 ml-2 font-semibold cursor-pointer mr-2" >
      {{user().name}}
    </span>
<!--    <p-button icon="pi pi-power-off" [rounded]="true" [text]="true" (click)="logout()" [pTooltip]="'logout'"/>-->
    <p-menu #menu [model]="userActions" [popup]="true" />
    <p-button (onClick)="menu.toggle($event)" icon="pi pi-chevron-down" class="ml-2" [text]="true"/>
  </div>
</div>
